export const services = [
  {
    id: 'vinduespudsning',
    title: 'Vinduespudsning',
    description: 'Krystalklare ruder og et fejlfrit udsyn. Vi sørger for professionel polering af alle glastyper.',
    image: '3.jpeg'
  },
  {
    id: 'rengoering',
    title: 'Rengøring',
    description: 'Effektiv og grundig rengøring af private hjem og erhvervslokaler med fokus på detaljen.',
    image: 'cleaning.jpg'
  }
];

export const processSteps = [
  {
    number: '01',
    title: 'Kontakt os',
    text: 'Send en besked eller ring for en uforpligtende snak om dine behov og ønsker.'
  },
  {
    number: '02',
    title: 'Tilbudsgivning',
    text: 'Vi vurderer opgavens omfang og sender dig et skarpt og gennemsigtigt tilbud.'
  },
  {
    number: '03',
    title: 'Udførelse',
    text: 'Vores professionelle team klarer opgaven til tiden og med højeste kvalitet.'
  }
];
